import * as React from 'react'

import { SbEditableBlok } from '@storyblok/storyblok-editable'

import { ContactPanel } from '../modules/ContactPanel'
import { ContactPersons } from '../modules/ContactPersons'
import { Disturber } from '../modules/Disturber'
import { Downloads } from '../modules/Downloads'
import { FeaturesList } from '../modules/FeaturesList'
import { FeaturesTable } from '../modules/FeaturesTable'
import { HeroTitle } from '../modules/HeroTitle'
import { HeroTitleDynamic } from '../modules/HeroTitleDynamic'
import { ImageCarousel } from '../modules/ImageCarousel'
import { LogoCarousel } from '../modules/LogoCarousel'
import { NewsletterDisturber } from '../modules/NewsletterDisturber'
import { RecurringModule } from '../modules/RecurringModule'
import { TabTeaserModule } from '../modules/TabTeaser'
import { TeaserCardCollage } from '../modules/TeaserCardCollage'
import { TeaserCardGrid } from '../modules/TeaserCardGrid'
import { TestimonialSlider } from '../modules/TestimonialSlider'
import { TextBox } from '../modules/TextBox'
import { TextColumns } from '../modules/TextColumns'
import { TextMedia } from '../modules/TextMedia'
import { RegistrationPanel } from '../modules/RegistrationPanel'
import { GlossaryList } from '../modules/GlossaryList'
import { Hint } from '../modules/Hint'
import { DownloadsBlog } from '../modules/DownloadsBlog'
import { DisturberBlog } from '../modules/DisturberBlog'
import { RecommendedArticlesTeaser } from '../modules/RecommendedArticlesTeaser'
import { BlogRTE } from '../modules/BlogRTE'
import { ImageVideo } from '../modules/ImageVideo'
import { ProductTeaser } from '../modules/ProductTeaser'
import { ImageVideoSlider } from '../modules/ImageVideoSlider'
import { CustomerStoriesItem } from '../modules/RecommendedArticlesTeaser/RecommendedArticleItem/CustomerStoriesItem'
import { EmailSubmit } from '../modules/EmailSubmit'
import { PricingModule } from '../modules/PricingModule'
import { TeaserCardItemV2 } from '../modules/TeaserCardItemV2'
import { TeaserCardStepsGrid } from '../modules/TeaserCardStepsGrid'
import { TextTable } from '../modules/TextTable'
import { LegalDocumentHeader } from '../modules/LegalDocumentHeader'
import { HeroBannerModule } from '../modules/HeroBanner'
import HeroModuleContent from '../modules/HeroModule/HeroModuleContent'
import HeroModuleTag from '../modules/HeroModule/HeroModuleTag'
import DeveloperModuleContent from '../modules/DeveloperModule/DeveloperModule'
import FeatureModuleContent from '../modules/FeatureModule/FeatureModule'
import DifferenceModuleContent from '../modules/DifferenceModule/DifferenceModuleContent'
import IntegrationModuleContent from '../modules/IntegrationModule/IntegrationModuleContent'
import ContactModule from '../modules/ContactModule/ContactModule'
const Components = {
  ContactPanel,
  ContactPersons,
  Disturber,
  DisturberBlog,
  DisturberUniversal: Disturber,
  Downloads,
  DownloadsBlog,
  FeaturesList,
  FeaturesTable,
  GlossaryList,
  HeroTitle,
  HeroTitleDynamic,
  Hint,
  ImageCarousel,
  ImageVideo,
  LogoCarousel,
  NewsletterDisturber,
  BlogRTE,
  RecommendedArticlesTeaser,
  RecurringModule,
  RegistrationPanel,
  TabTeaser: TabTeaserModule,
  TeaserCardCollage,
  TeaserCardGrid,
  TeaserCardStepsGrid,
  PricingModule,
  HeroBannerModule,
  TeaserCardItemV2,
  TestimonialSlider,
  TextBox,
  TextColumns,
  TextMedia,
  ImageVideoSlider,
  ProductTeaser,
  CustomerStoriesItem,
  EmailSubmit,
  TextTable,
  LegalDocumentHeader,
  HeroModuleContent,
  HeroModuleTag,
  DeveloperModuleContent,
  FeatureModuleContent,
  DifferenceModuleContent,
  IntegrationModuleContent,
  ContactModule
}

export const DynamicComponent = ({ blok }: { blok: SbEditableBlok }) => {
  if (typeof Components[blok.component] !== 'undefined') {
    const Component = Components[blok.component]

    return <Component blok={blok} />
  }

  return (
    <p>
      Component <strong>{blok.component}</strong> has not been created yet …
    </p>
  )
}
